import { atomWithStorage } from '@capsicum/common';

// An atom to confirm if it's the first time the user lands on the congratulations screen
export const firstTimeCongratsScreenAtom = atomWithStorage<boolean>('firstTimeCongratsScreen', true);
